import { useContext } from 'react';

import { NewReviewContext } from './NewReviewContext';

export const useNewReviewContext = () => {
  const context = useContext(NewReviewContext);

  return context;
};
